class DOMIDs {
  prefix = 'rg-widget';

  createId(id) {
    return `${this.prefix}-${id}`;
  }

  get frame() {
    return this.createId('frame');
  }

  get featureIcons() {
    return this.createId('compact');
  }

  get messenger() {
    return this.createId('messenger');
  }

  get compact() {
    return this.featureIcons;
  }

  get bubbles() {
    return this.createId('bubbles');
  }

  get relativeNode() {
    return 'rg-widget-relative';
  }
}

export const rgIDs = new DOMIDs();

